import { Column } from 'src/shared/components/Semantic/all'
import { useProductImageUpload } from '../../hooks'
import { VariantProps } from './types'
import { useNewColorForm } from './hooks'
import { NewColorSection } from './components/NewColorSection'
import { ExistingColorsSection } from './components/ExistingColorsSection'

export const Variant = ({
  variant,
  onNewColorChange,
  onColorItemChange,
}: VariantProps) => {
  const {
    color,
    setColor,
    imageUrls,
    setImageUrls,
    handleSaveNewColor,
    isSaving,
  } = useNewColorForm(variant.id, onNewColorChange)

  const { handleImageUpload, isUploading, error } = useProductImageUpload(
    imageUrls,
    setImageUrls
  )

  const product_variant_colors =
    variant?.product_variant_color as unknown as any[]

  return (
    <>
      <p className="text-xs ml-1 mb-2 text-muted-foreground">
        (Colors for {variant.item_name || 'default variant'})
      </p>

      <Column className="gap-6">
        <NewColorSection
          variantId={variant.id}
          color={color}
          setColor={setColor}
          imageUrls={imageUrls}
          setImageUrls={setImageUrls}
          handleImageUpload={handleImageUpload}
          isUploading={isUploading}
          error={error}
          onSave={handleSaveNewColor}
          isSaving={isSaving}
        />

        <ExistingColorsSection
          productVariantColors={product_variant_colors}
          onColorItemChange={onColorItemChange}
        />
      </Column>
    </>
  )
}
